
import { SearchOutlined } from '@ant-design/icons'
import { Input, List } from 'antd'

import React, { useState } from 'react'

function StationNameSearch({ stations, handleChange, style,classes, defaultValue }) {
    const [text, setText] = useState(defaultValue);
    const [suggestions, setSuggestions] = useState([]);
    const [selectedStation, setSelectedStation] = useState(defaultValue)
    const [isStationBlank, setIsStationBlank] = useState(false)


    function onTextChanged(e) {
        let value = e.target.value;
        let suggests = [];
        if (value.length > 0) {
            value = value.replace(/[^\w\s]/gi, '');
            const regex = new RegExp(`^${value}`, "i");
            suggests = stations
                .sort()
                .filter(station => regex.test(station));
        }
        setSuggestions(suggests);
        setText(value);
        if (!value) {
            setIsStationBlank(true)
            handleChange('')
        } else {
            setIsStationBlank(false)
        }

    }

    function suggestionSelected(suggestion) {

        setText(suggestion);
        setSuggestions([]);
        setSelectedStation(suggestion)
        handleChange(suggestion)
        setIsStationBlank(false)

    }

    function renderProject() {

        if (suggestions.length === 0) {
            return null;
        }
        return (
            <List className='list-style search-station-name' id="stationList" >
                {suggestions.map((suggestion, index) => (
                    <List.Item className='list-item' onClick={() => suggestionSelected(suggestion)} key={suggestion + index}>
                        {suggestion}
                    </List.Item>
                ))}
            </List>
        );
    }

    const hideStationList = () => {
        const stationListElement = document.getElementById('stationList')
        const addStationElement = document.getElementById('addStation')
        window.onclick = function (e) {
            if (e.target != stationListElement && e.target != addStationElement) {
                setSuggestions([])
            }
        }
    }

    return (
        <>
            <Input
               id="addStation"
                className={classes}
                autoComplete="off"
                value={text}
                onChange={onTextChanged}
                type="text"
                allowClear
                status="error"
                // style={{ height: 32, width: '80%' }}
                style={style}
                //  style={{ height: 40,display:'flex',alignItems:'center',overflow:'hidden' }}
                placeholder="Search Station Name"
                prefix={<SearchOutlined id="search-icon"
                />}
                onFocus={() => { setSuggestions(stations.slice(0, 10)); }}
                onBlur={hideStationList}
            />
            {/* {isStationBlank &&
                <div className="ant-form-item-explain ant-form-item-explain-error">
                    <div role="alert">Station Name is required.</div>
                </div>
            } */}
            <span className={"stationNameDropdown "} >{renderProject()}</span>

        </>
    )
}

export default StationNameSearch;            